// Depois de um deploy, a aba que ficou aberta ainda aponta pros chunks do build
// antigo: o `import()` de uma rota lazy (abrir o builder do Studio; abrir o
// painel do widget no site do cliente) pede um hash que não existe mais, o
// Rails responde 404 (`RoutingError ... /vite/assets/X-<hash antigo>.js` no
// log de prod) e o clique morre em silêncio — sem toast, sem navegação, até
// alguém dar F5. O Vite dispara `vite:preloadError` nesse caso, tanto pro
// módulo da rota quanto pros deps pré-carregados. Recarregar traz o manifest
// novo. Receita da doc do Vite. Compartilhado: dashboard e widget.
//
// Guarda anti-loop: se o asset sumiu de verdade (build quebrado), recarregar de
// novo não resolve. Depois de UM reload recente, deixamos o erro subir (console
// + Sentry) em vez de girar a página pra sempre. A guarda vive em
// sessionStorage; se o storage está bloqueado (iframe de terceiro no Safari,
// modo estrito), NÃO recarregamos — sem guarda, um build quebrado viraria
// reload infinito do iframe do widget batendo no nosso servidor. Fica o erro
// original, que é o comportamento de hoje.
export const RELOAD_GUARD_KEY = 'vite-preload-error-reloaded-at';
export const RELOAD_GUARD_WINDOW_MS = 60_000;

const readGuard = win => {
  try {
    return {
      ok: true,
      at: Number(win.sessionStorage.getItem(RELOAD_GUARD_KEY)),
    };
  } catch {
    return { ok: false, at: 0 };
  }
};

export const installVitePreloadErrorReload = (win = window, now = Date.now) => {
  win.addEventListener('vite:preloadError', event => {
    const guard = readGuard(win);
    if (!guard.ok) return;
    if (guard.at && now() - guard.at < RELOAD_GUARD_WINDOW_MS) return;

    win.sessionStorage.setItem(RELOAD_GUARD_KEY, String(now()));
    event.preventDefault();
    win.location.reload();
  });
};
